<template>
  <v-app dark>
    <!-- Desktop -->
    <v-toolbar
      v-if="loggedIn && $vuetify.breakpoint.mdAndUp"
      fixed
      class="elevation-0"
      color="dark"
    >
      <!-- Welcome -->
      <v-flex md2 lg3 class="font-number-2" style="font-size: 35px!important;">
        <span v-lang.welcome></span>
        , {{$store.getters.getUser.displayName}}
      </v-flex>
      <!-- Navigation -->
      <v-flex md8 lg6>
        <v-layout align-center justify-center>
          <v-btn round v-for="item in pagelinks" :key="item.title" :to="item.route">
            <v-flex v-if="language == 'en'">
              {{item.en}}&nbsp;&nbsp;
              <v-icon>{{item.icon}}</v-icon>
            </v-flex>
            <v-flex v-else-if="language == 'fi'">
              {{item.fi}}&nbsp;&nbsp;
              <v-icon>{{item.icon}}</v-icon>
            </v-flex>
            <v-flex v-else-if="language == 'sv'">
              {{item.sv}}&nbsp;&nbsp;
              <v-icon>{{item.icon}}</v-icon>
            </v-flex>
          </v-btn>
        </v-layout>
      </v-flex>
      <!-- Log Off Button -->
      <v-flex md2 lg3 text-xs-right>
        <v-btn round class="error" @click="logout">
          <a class="white--text" v-lang.logoff></a>&nbsp;&nbsp;
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar>
    <!-- Mobile -->
    <v-toolbar
      v-if="loggedIn && $vuetify.breakpoint.mdAndDown"
      fixed
      class="elevation-0"
      color="dark"
    >
      <v-btn class="ml-1 my-0" icon fab @click.stop="drawer = !drawer" elevation-10>
        <v-icon>menu</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="mobileStyle">{{getTitle}}</v-toolbar-title>
    </v-toolbar>
    <!-- Side Menu -->
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.mdAndDown"
      temporary
      left
      clipped
      fixed
      v-model="drawer"
      class="black mb-0 pb-0"
    >
      <!-- Close & Title -->
      <v-layout row wrap align-center justify-center>
        <v-flex xs6 class="text-xs-left">
          <v-btn icon @click="drawer= false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="text-xs-right mobileStyle pr-3">{{$store.getters.getUser.displayName}}</v-flex>
      </v-layout>
      <!-- Items List -->
      <v-list id="titleList" class="ml-5 pl-2">
        <v-list-tile v-for="item in pagelinks" :key="item.en">
          <router-link
            :to="item.route"
            class="pageLinks mx-auto"
            :style="{ 'color':pageLinkSel(item.route)}"
          >
            <v-list-tile-content class="mobileStyle icon-transform-1">
              <v-list-tile-title v-if="language == 'en'">
                <v-icon>{{item.icon}}</v-icon>
                {{ item.en }}
              </v-list-tile-title>
              <v-list-tile-title v-else-if="language == 'fi'">
                <v-icon>{{item.icon}}</v-icon>
                {{ item.fi }}
              </v-list-tile-title>
              <v-list-tile-title v-else-if="language == 'sv'">
                <v-icon>{{item.icon}}</v-icon>
                {{ item.sv }}
              </v-list-tile-title>
            </v-list-tile-content>
          </router-link>
        </v-list-tile>
      </v-list>
      <!-- Log Off Button -->
      <v-container style="position:absolute;bottom:0px;">
        <v-flex xs12 text-xs-center>
          <v-btn round class="error" @click="logout">
            <a class="white--text" v-lang.logoff></a>&nbsp;&nbsp;
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-flex>
      </v-container>
    </v-navigation-drawer>
    <!-- Dialog -->  
    <v-dialog v-model="getDialogMessage" persistent max-width="400">
      <v-card class="roundCard">
        <v-card-title>
          <v-progress-circular :width="5" color="primary" indeterminate></v-progress-circular>
          <v-flex text-xs-center class="font-heading white--text">{{$store.getters.getMessage}}</v-flex>
        </v-card-title>
      </v-card>
    </v-dialog>
    <!-- Content -->
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    username: "Admin",
    drawer: null,
    CLOCK: null,
    tempSwitch: true,
    toolbarFlag: false,
    pagelinks: [
      {
        en: "Schedules",
        fi: "Aikataulut",
        sv: "Scheman",
        route: "/Schedules",
        icon: "schedule"
      },
      {
        en: "Statistics",
        fi: "Statistiikka",
        sv: "Statistik",
        route: "/Statistics",
        icon: "bar_chart"
      },
      {
        en: "Help",
        fi: "Ohje",
        sv: "Hjälp",
        route: "/Help",
        icon: "help_outline"
      }
    ]
  }),
  props: {
    source: String
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout");
    },
    startTime: function() {
      var today = new Date();
      var self = this;
      var h = today.getHours();
      var m = today.getMinutes();
      m = this.checkTime(m);
      this.CLOCK = h + ":" + m;
      var t = setTimeout(self.startTime, 500);
    },
    checkTime: function(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    pageLinkSel: function(link) {
      if (this.$route.path.substr(1) === link) {
        return "grey";
      } else {
        return "white";
      }
    },
  },
  computed: {
    getDialogMessage() {
      if (this.$store.getters.getMessage !== null) {
        return true;
      } else {
        return false;      
      }
    },
    

    loggedIn: function() {
      return this.$store.getters.getUser;
    },
    getTitle: function() {
      if (this.$route.path.substr(1) == "Login") {
        this.toolbarFlag = false;
      } else {
        this.toolbarFlag = true;
        let x = this.pagelinks.find(el => {
          return this.$route.path == el.route;
        });
        if (x !== undefined) {
          if (this.language == "en") {
            return x.en;
          } else if (this.language == "fi") {
            return x.fi;
          } else {
            return x.sv;
          }
        }
      }
    }
  },
  mounted() {
    this.startTime();
  }
};
</script>

<style>
.ew-logo-small {
  bottom: 0px;
  position: absolute;
}

.pageLinks {
  color: white;
  text-decoration: none;
}

#titleList {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

#titleList .list__tile {
  height: 50px !important;
}

#titleList .list__tile__title {
  height: 100% !important;
  line-height: normal !important;
}

.mobileStyle {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: lighter;
  font-size: 2em;
}

.roundCard {
  border-radius: 35px;
}

.dialog {
  border-radius: 35px !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue